const orderList = listArray => {
  if (listArray?.length) {
    return listArray.sort(
      (acc, cur) => new Date(cur.date_stamp) - new Date(acc.date_stamp)
    );
  }
};
export default orderList;
